// Re:Vault - brand constants. Single source for the name, logo, and copy so
// every surface (app, settings, folders, errors, policy pages) stays consistent.

export const NAME = "Re:Vault";
export const TAGLINE = "Your study space, all in one place.";
export const DESCRIPTION =
	"Re:Vault is a fast, private study browser built for Chromebooks - a distraction-free learning workspace with a built-in library, study tools, worksheets, and a clean tabbed reader for research and classwork.";

// Gold mortarboard / vault mark used throughout the UI.
export const LOGO_SVG = `<svg viewBox="0 0 32 32" fill="none" aria-hidden="true"><circle cx="16" cy="15" r="11" fill="var(--accent)" opacity="0.15"></circle><path d="M16 7 L29 12 L16 17 L3 12 Z" fill="var(--accent)"></path><path d="M9.5 14 L9.5 19 C9.5 21 12.5 22 16 22 C19.5 22 22.5 21 22.5 19 L22.5 14 L16 17 Z" fill="var(--accent-2)"></path><path d="M29 12 L29 19" stroke="var(--accent)" stroke-width="1.2" stroke-linecap="round"></path><circle cx="29" cy="20.3" r="1.5" fill="var(--accent)"></circle></svg>`;

// Inject the logo into an element by id (used by app + settings entries).
export function mountLogo(el) {
	if (el) el.innerHTML = LOGO_SVG;
}
